<template>
    <div class="home">
        <div class="home_banner">
            <el-carousel class="announce_news" v-if="bannerList.length > 0">
                <el-carousel-item v-for="item in bannerList" :key="item.id">
                    <img :src="item.bannerUrl" alt="">
                </el-carousel-item>
            </el-carousel>
            <div class="default_banner" v-if="bannerList.length == 0"></div>
            <div class="bannerDev fc">
                <div class="tit">
                    <ul>
                        <li>
                            <div>设备连接数</div>
                            <p>{{achieve.deviceCount||0}}</p>
                        </li>
                        <li>
                            <div>微服务组件</div>
                            <p>{{achieve.microService||0}}</p>
                        </li>
                        <li>
                            <div>机理模型</div>
                            <p>{{achieve.model||0}}</p>
                        </li>
                        <li>
                            <div>工业数据</div>
                            <p>{{achieve.data||0}}</p>
                        </li>
                        <li>
                            <div>工业APP</div>
                            <p>{{achieve.appNum||0}}</p>
                        </li>
                        <li>
                            <div>平台租户</div>
                            <p>{{achieve.tenantNum||0}}</p>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <!-- 平台介绍 -->
        <div class="homeVerliy fc">
            <ul class="server">
                <li>
                    <div>
                        <p>IaaS层资源服务</p>
                        <div class="detail">
                            基于虚拟化、分布式数据存储、资源负责管理、工作流服务、数据库服务、控制访问等技术，实现计算、数据和网络资源的管理，为用户提供完善的基础设施服务。
                        </div>
                    </div>
                    <div><img src="@/assets/home/home_IaaS.png" alt=""></div>
                </li>
                <li>
                    <div>
                        <p>PaaS层平台能力</p>
                        <div class="detail">
                            基于云平台扩展人工智能平台，开发面向研发、生产、质检、安全等环节的工业机理模型，积累企业核心数字资产。
                        </div>
                    </div>
                    <div><img src="@/assets/home/home_paas.png" alt=""></div>
                </li>
                <li>
                    <div>
                        <p>SaaS层应用共享</p>
                        <div class="detail">
                            平台将融合微应用、B/S、 移动APP等技术，面向营销、智能、供应链和质量追溯等多场景应用需求，提供丰富的工业APP。
                        </div>
                    </div>
                    <div><img src="@/assets/home/home_saas.png" alt=""></div>
                </li>
                <li>
                    <div>
                        <p>边缘层设备接入</p>
                        <div class="detail">
                            采集生产设备、能源设备等关键生产、运行数据，基于云平台可快速扩展大数据平台能力以管理多源异构的工业数据。
                        </div>
                    </div>
                    <div><img src="@/assets/home/home_margin.png" alt=""></div>
                </li>
            </ul>
        </div>
        <!--  -->
        <div class="homeVerliy food">
            <div class="fc">
                <div class="foodName">打通食品产业链条，促进产业转型升级</div>
                <div class="foodDetail">以卫龙辣味食品制造云工业互联网平台为载体，打破食品产业传统壁垒，打通食品产业链条，共同探索食品行业新技术、新应用、新发展、新业态，形成开放共荣、协同发展的创新体系</div>
                <div class="foodMain">
                    <ul class="foodLeft">
                        <li :class="accessFood == 'one' ? 'active' : ''" @click="getfood('one')">
                            <img src="@/assets/home/home_pepper.png" alt="">
                            <span>促进食品行业企业的可持续高质量发展</span>
                        </li>
                        <li :class="accessFood == 'two' ? 'active' : ''" @click="getfood('two')">
                            <img src="@/assets/home/home_pepper.png" alt="">
                            <span>规范食品追溯并推动政府常态化监管</span>
                        </li>
                        <li :class="accessFood == 'three' ? 'active' : ''" @click="getfood('three')">
                            <img src="@/assets/home/home_pepper.png" alt="">
                            <span>净化食品市场环境，规范市场秩序</span>
                        </li>
                        <li :class="accessFood == 'four' ? 'active' : ''" @click="getfood('four')">
                            <img src="@/assets/home/home_pepper.png" alt="">
                            <span>推动中国美食走出国门，享誉世界</span>
                        </li>
                    </ul>
                    <div class="foodRight">
                        <div class="desc">{{foodList[accessFood]}}</div>
                    </div>
                </div>
            </div>
           
        </div>
        <!--  社区-->
        <div  class="homeVerliy fc">
            <div class="homeTop">
                <div class="head">DYNAMICS
                    <div class="communTop">
                        <p>社区动态</p>
                        <div class="line"></div>
                    </div>
                </div>
                <div @click="comClick" class="dynLook">查看详情 <img src="../../assets/home/home_more.png" alt=""></div>
            </div>
            <div class="community">
                <div class="communityLeft">
                    <div class="communDyn">
                        <div class="comhot"><img src="../../assets/home/home_diamond.png" alt=""><span>热门讨论</span></div>
                        <div class="more">
                            <a :href="platformUrl + `/developerWeb/#/community`" target="_blank">
                                <span>查看更多</span>
                                <img src="@/assets/home/home_more1.png" alt="">
                            </a>
                        </div>
                        <!-- <div class="" >查看更多</div> -->
                    </div>
                    <ul v-if="hotList.length>0">
                        <li v-for="(item,index) in hotList" :key="index" @click="hotClick(item)">
                            <div>{{item.articleTitle}}</div>
                            <div>{{item.time}}</div>
                        </li>
                    </ul>
                    <div class="nodata" v-if="hotList.length == 0">
                        <img src="@/assets/nodata.png" alt="">
                        <p>暂无数据~</p>
                    </div>
                </div>
                <div class="communityRight">
                    <div class="communDyn">
                        <div class="comhot"><img src="../../assets/home/home_diamond.png" alt=""><span>热门文档</span></div>
                    </div>
                    <ul class="projiectOpen" v-if="AccountList.length>0">
                        <li @click="getOpen(item)" v-for="(item,index) in AccountList" :key="index">{{item.title}}</li>
                    </ul>
                    <div class="nodata" v-if="AccountList.length == 0">
                        <img src="@/assets/nodata.png" alt="">
                        <p>暂无数据~</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="homeVerliy apply">
            <div class="fc">
                <div class="homeTop">
                    <div class="head">APPLICATION
                        <div class="communTop">
                            <p>优选应用</p>
                            <div class="line"></div>
                        </div>
                    </div>
                    <div @click="gotToApp" class="dynLook">查看详情 <img src="@/assets/home/home_more.png" alt=""></div>
                </div>
                <div v-if="appList.length > 0">
                   <ul>
                        <li v-for="itemApp in appList" :key="itemApp.portalAppId">
                            <div>
                                <img :src="showUrl+itemApp.imgUrl" alt="">
                                <!-- <img src="@/assets/home/home_application03.png" alt=""> -->
                            </div>
                            <p>{{ itemApp.appName }}</p>
                            <div class="detail">{{itemApp.description}}</div>
                            <div class="app">{{itemApp.statusName}}</div>
                            <div class="money" v-if="itemApp.priceType!='金额'">{{itemApp.priceTypeName}}</div>
                            <div class="money" v-else>{{itemApp.price}}<span>元/年</span></div>
                            <div class="access" @click="gotToInfo(itemApp.portalAppId)" >立即获取</div>
                        </li>
                   </ul> 
                </div>
                <div class="nodata" v-if="appList.length == 0">
                    <img src="@/assets/nodata.png" alt="">
                    <p>暂无数据~</p>
                </div>
            </div>
        </div>
        
    </div>
</template>

<script>
import Swiper from "swiper"
// import { Swiper, SwiperSlide, Grid, Pagination } from 'swiper';
import "swiper/css/swiper.css";
import CountTo from 'vue-count-to'
import Pass from './pass'
import { showUrl, platformUrl, getIndexList, getModelInfoList, getHotDiscussList, getPortalList, getPlatformAchievement, getCaseList, getServiceList, getBannerByPosition,getDocumentInfoList } from '@/api/api'
export default {
    name: "",
    components: {
        Pass,
        CountTo
    },
    data() {
        return {
            showUrl,
            platformUrl,
            accessFood:'one',
            bannerList: [],
            capacityBanner: 'mechanismModel',
            mechanismModelList: [],
            microServiceList: [],
            topList: [],
            hotList: [],
            appList: [],
            leftNavOne: true,
            leftNavTwo: false,
            leftNavThree: false,
            leftNavFour: false,
           foodList:{
            one:'卫龙辣味食品制造云工业互联网平台将起到食品行业的数智化引领作用，让更多的食品相关企业加入进来。卫龙美味将分享自己的食品行业工业互联网整体解决方案，其他企业可在该平台基础之上，结合自身情况，快速构建自己的工业互联网体系;并逐渐带动该企业的供应链，建立自己的供应链协同体系。卫龙美味将与各企业保持密切沟通，建立食品行业工业互联网产业联盟，结合各企业工业互联网建设情况，给出优化建议;在建设过程中遇到的问题，卫龙美味将予以搜集，并持续优化自身的工业互联网基础平台，形成良性循环。最终推动食品企业、食品产业、食品市场的稳定、健康、高质量发展。',
            two:'规范食品追溯并推动政府常态化监管卫龙辣味食品制造云工业互联网平台使用标识解析、大数据、区块链等技术，将建立完整覆盖食品原料、加工、检验、包装、库存、运输、销售的全链条、全生命周期的可视化、透明化、防篡改的追溯机制。通过平台建立规范的食品安全追溯体系，切实保障消费者与经销商权益，建立消费者与经销商信任;平台也将预留充分接口，逐步与政府部门监管平台对接，将工业互联网平台的食品企业和供应链企业的食品生产全过程信息，在政府部门内部监管平台实时展示，实时监管，探索并一步步完善常态化监管体系，并为制定与时俱进、更科学、更严谨的食品安全监管条例提供重要依据。',
            three:'净化食品市场环境，规范市场秩序卫龙辣味食品制造云工业互联网平台将打破各个食品产业链 -22-上下游企业的信息枷锁，利用工业数据驱动，突破食品企业内外割裂的生产方式，能够整合产业链上下游企业由单链条串行生产方式转变为多环节并行协作方式，进行食品供应链企业的产业资源整合，实现产业链上下游的协同联动;逐步建立食品行业工业互联网产业联盟，协同一体发展，规范市场秩序，建立良好市场风气，推动食品产业可持续发展。',
            four:'推动中国美食走出国门，享誉世界卫龙美味将依托工业互联网平台，与国际先进食品企业、国际大型连锁超市、国际物流商、国际电商平台合作，逐步建立国外的销售、运输通路，并实现在国外建立自己的加工工厂的目标。卫龙美味的成功案例也将作为标杆示范作用，带动更多的中国食品企业迈向海外，与卫龙一起享誉世界。'
           },
           AccountList:[],
            caseList: [],
            achieve: {
                appNum: '',
                tenantNum: '',
                cooperationNum: '',
                data: '',
                deviceCount: '',
                enterpriseNum: '',
                microService: '',
                model: ''
            },
            loopNum: 0,  //平台介绍轮播
            timer: "", //绑定定时器
        };
    },
    created() {
    
    },
    mounted() {
        // this.getBannerList()
        this.getIndexList()
        this.getHotList()
        this.getAppliction()
        this.getPlatformAchievement()
        this.getDocument()
    },
    beforeDestroy() {
        if (this.timer) {
            clearInterval(this.timer);
        }
    },

    methods: {
        // 
        hotClick(item){
            window.open(this.platformUrl+`/developerWeb/#/post/postDetail?id=${item.articleId}&articleUserId=${item.articleUserId}`);
        },
        // 
        getOpen(item){
            window.open(this.platformUrl+`/openWeb/#/file?projectId=${item.projectId}&projectName=${item.projectName}&classifyId=${item.classifyId}&documentId=${item.documentId}`);
        },
        // 
        getfood(val){
            this.accessFood=val
        },
        comClick(){
            if (process.env.NODE_ENV === "development") {
                // 开发环境
                window.open(`http://192.168.4.146:9528/#/community`);
            } else {
                // 正式环境
                //   path = process.env.VUE_APP_PLATFORM_URL 
                window.open(this.platformUrl + `/developerWeb/#/community`);
            }
        },
        // banner
        getBannerList() {
            let data = {
                position: '005'
                // isNew:'1'
            }
            getBannerByPosition(data).then(res => {
                this.bannerList = res.data
            })
        },
        // 置顶推荐
        getIndexList() {
            let data = {}
            getIndexList(data).then(res => {
                if (res.code == 0) {
                    // this.topList = res.data.data
                    this.topList = []
                    var getList = res.data.data
                    getList.forEach(i => {
                        // debugger
                        // console.log(i)
                        var obj = {
                            child: i
                        }
                        this.topList.push(obj)
                    });
                }
            })
        },
        gotToApp(){
            if (process.env.NODE_ENV === "development") {
                // 开发环境
                window.open(`http://192.168.4.146:9528/#/applyList`);
            } else {
                // 正式环境
                //   path = process.env.VUE_APP_PLATFORM_URL 
                window.open(this.platformUrl + `/applyWeb/#/applyList`);
            }
        },
        // 跳转应用市场详情页
        gotToInfo(id) {
            if (process.env.NODE_ENV === "development") {
                // 开发环境
                window.open(`http://192.168.4.146:9528/#/applyInfo?appId=${id}`);
            } else {
                // 正式环境
                //   path = process.env.VUE_APP_PLATFORM_URL 
                window.open(this.platformUrl + `/applyWeb/#/applyInfo?appId=${id}`);
            }
        },
        // 获取开发者中心热门讨论
        getHotList() {
            let data = {
                start: 1,
                length: 10
            }
            getHotDiscussList(data).then(res => {
                if (res.code === 0) {
                    this.hotList = res.data.data
                }
            })
        },
        // 热搜文档
        getDocument(){
            let data = {
                
                state:0
            } 
            getDocumentInfoList(data).then(res => {
                if (res.code === 0) { 
                    this.AccountList=[]
                    this.AccountList=[] = res.data.data
                    
                    // getdoc.forEach((item)=>{
                    //     this.AccountList.push(item.typeName)
                    // })
                }
            })
        },
        // 获取行业应用列表
        getAppliction() {
            let data = {
                start: 1,
                length: 3
            }
            getPortalList(data).then(res => {
                if (res.code == 0) {
                    this.appList = res.data.data
                }
            })
        },
      
        // 平台成就
        getPlatformAchievement() {
            getPlatformAchievement().then(res => {
                if (res.code == 0) {
                    Object.keys(this.achieve).forEach(key => {
                        this.$set(this.achieve, key, res.data[key])
                    })
                }
            })
        },
        // 跳转详情页
        goToDetail(id) {
            this.$router.push({ path: '/home/detail', query: { id } })
        },
    },
}
</script>

<style lang="less" scoped>
// 媒体查询开始
body {


    .capacity_banners {
        /deep/ .el-carousel__container {
            position: relative;
            height: 454px; // 684 - (148 + 52 + (64 - 30))
            // background-color: #fff !important;
        }
    }

    @media screen and (min-width : 1350px) {

        .capacity_banners {
            /deep/.el-carousel {
                position: relative;
                width: 1340px;
                margin-left: -60px;
                // background-color: #fff !important;
            }



            /deep/ .el-carousel__item.is-animating {
                padding: 30px 60px;
            }

            .top_list {
                width: 600px;
            }

            .mechanism_list {
                width: 290px;
            }

            .microService_list {
                width: 290px;
            }
        }
    }

    @media screen and (max-width:1349px) {

        .capacity_banners {
            /deep/.el-carousel {
                position: relative;
                width: 1220px;
                // background-color: #fff !important;
            }

            /deep/ .el-carousel__item.is-animating {
                padding: 30px 10px;
                // background-color: #d13636 !important;
            }

            .top_list {
                width: 590px;
            }

            .mechanism_list {
                width: 286px;
            }

            .microService_list {
                width: 285px;
            }
        }
    }

    @media screen and (min-width : 1430px) {
        .introduction {
            .fc {
                .introduce {
                    position: relative;
                    height: 859px;

                    .framework_text,
                    .user_text,
                    .service_text,
                    .value_text,
                    .data_text,
                    .application_text {
                        background: rgba(240, 242, 245, 0.8);
                        background-size: cover;
                        width: 280px;
                        padding: 19px 20px;
                        position: absolute;
                        // opacity: 0;

                        // visibility: hidden;
                        // transition: all 0.6s linear;

                        // &:hover {
                        //     visibility: visible;
                        //     opacity: 1;
                        // }
                    }

                    .user_text {
                        left: -85px;
                        bottom: 210px;
                    }

                    .data_text {
                        top: 140px;
                        right: -100px;
                    }

                    .user:hover+.user_text {
                        // display: block;
                        opacity: 1;
                        visibility: visible;
                    }

                    .data:hover+.data_text {
                        // display: block;
                        opacity: 1;
                        visibility: visible;
                    }
                }
            }
        }

    }

    @media screen and (max-width : 1429px) {
        .introduction {
            .fc {
                .introduce {
                    position: relative;
                    height: 859px;

                    .framework_text,
                    .user_text,
                    .service_text,
                    .value_text,
                    .data_text,
                    .application_text {
                        background: rgba(240, 242, 245, 0.8);
                        background-size: cover;
                        width: 280px;
                        padding: 19px 20px;
                        position: absolute;
                        opacity: 0;

                        visibility: hidden;
                        transition: all 0.6s linear;

                        &:hover {
                            // display: block;
                            visibility: visible;
                            opacity: 1;
                        }
                    }

                    .user_text {
                        left: -26px;
                        bottom: 210px;
                    }

                    .data_text {
                        top: 140px;
                        right: 0px;
                    }

                    .user:hover+.user_text {
                        // display: block;
                        opacity: 1;
                        visibility: visible;
                    }

                    .data:hover+.data_text {
                        // display: block;
                        opacity: 1;
                        visibility: visible;
                    }
                }
            }
        }
    }
}

// 媒体查询结束
/deep/ .el-carousel__arrow {
    width: 40px !important;
    height: 40px !important;
    background-color: #cccccc;
    font-size: 24px;

    &:hover {
        background-color: #0055ff;
    }
}

/deep/.el-carousel__arrow--left {
    left: 0;
}

/deep/.el-carousel__arrow--right {
    right: 0;
}
.default_banner {
    height: 750px;
    background-image: url("../../assets/home/home_banner.png");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    position: relative;
}

.home_banner {

    /deep/.el-carousel__container,
    .el-carousel__item {
        height: 750px;
    }

    height: 750px;

    img {
        width: 100%;
        height: 100%;
    }
}
.bannerDev{
    // position: absolute;
    height: 200px;
	background-color: rgba(255, 255, 255, 0.5);
    z-index: 1000;
    position: sticky;
    margin-top: -350px;
    ul{
        display: flex;
        justify-content: space-around;
        padding: 50px 0;
        li{
            div{
                font-size: 20px;
                color: #222222;
                margin-bottom: 30px;
            }
            p{
                font-size: 48px;
                color: #e60012;
                span{
                    color: #222222;
                    font-size: 16px;
                }
            }
        }
    }
}

.no_data {
    padding: 60px;
    text-align: center;

    p {
        margin-top: 20px;
        color: #666666;
    }
}
.homeVerliy{
    padding: 63px 0;
}
.server{
    display: flex;
    width: 100%;
    flex-wrap: wrap;
    li{
        width: calc(50% - 20px);
        background-color: #ffffff;
        border-radius: 4px;
        border: solid 1px #f0f0f0;
        display: flex;
        padding: 30px 15px 15px 30px;
        margin: 0 20px 20px 0;
        &:hover{
            background-image: linear-gradient(-45deg, #ffb2b9 0%, #fffafa 100%);
            border-radius: 4px;
            border: solid 1px #f0f0f0;
        }
        p{
            font-size: 28px;
	        color: #e60012;
            margin-bottom: 15px;
        }
        .detail{
            font-size: 16px;
            line-height: 30px;
            color: #666666;
        }
    }
    :nth-child(2){
        margin: 0 0 20px 0;
    }
    :nth-child(3){
        margin: 0 20px 0 0;
    }
    :nth-child(4){
        margin: 0;
    }
}
.food{
    background: url('../../assets/home/home_food_bg.png') center center no-repeat;
    background-size: cover;
    .foodName{
        font-size: 30px;
        line-height: 26px;
        color: #222222;
        margin-bottom: 20px;
    }
    .foodDetail{
        font-size: 16px;
        line-height: 30px;
        color: #666666;
    }
    .foodMain{
        display: flex;
        margin-top: 40px;
        padding: 60px 40px 60px 0;
        background-color: rgba(255, 255, 255, 0.5);
        border-radius: 4px;
        border: solid 1px #f0f0f0;
        .foodLeft{
            width: 40%;
            margin-right: 40px;
            border-right: 2px solid #ffffff;
            li{
                height: 58px;
                // text-align: center;
                padding: 0 20px;
                display: flex;
                align-items: center;
                margin-bottom: 12px;
                cursor: pointer;
                span{
                    font-size: 18px;
	                color: #222222;
                    margin-left: 10px;
                }
                &:hover {
                    background-color: #e60012;
                    span{
                        color: #fff; 
                    }
                }

                &.active {
                    background-color: #e60012;
                    span{
                        color: #fff; 
                    }
                }
            }
        }
        .foodRight{
            background: url('../../assets/home/home_food.png') center center no-repeat;
            background-size: cover;
            width: 718px;
	        height: 400px;
            .desc{
                font-size: 16px;
                line-height: 30px;
                color: #ffffff;
                padding: 32px 42px;
            }
        }
    }
}
.community{
    margin-top: 40px;
    display: flex;
    .communityLeft{
        width: calc(60% - 20px);
        background-color: #ffffff;
        border-radius: 4px;
        border: solid 1px #f0f0f0;
        padding: 32px 20px 0;
        margin-right: 20px;
        ul{
            margin: 20px 0;
            height: 400px;
            overflow: auto;
            li{
                display: flex;
                align-items: center;
                justify-content: space-between;
                height: 40px;
                line-height: 40px;
                padding: 12px 19px;
                cursor: pointer;
                &:nth-child(2n+1){
                    background-color: #f5f5f5;
                }
            }
        }
    }
    .communityRight{
        width: 40%;
        background-color: #ffffff;
        border-radius: 4px;
        border: solid 1px #f0f0f0;
        padding: 32px 20px 0;
        ul{
            margin: 20px 0;
            height: 400px;
            overflow: auto;
            li{
                height: 40px;
                padding: 12px 19px;
                &:nth-child(2n+1){
                    background-color: #f5f5f5;
                }
            }
        }
    }
}
.homeTop{
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.head{
    position: relative;
    font-size: 60px;
	line-height: 72px;
	color: #f0f0f0;
    .communTop{
        position: absolute;
        bottom: 0;
    }
    p{
        font-size: 30px;
        line-height: 26px;
        color: #222222;
    }
    .line{
        width: 40px;
        height: 3px;
        background-color: #e60012;
        margin-top: 12px;
    } 
}
.dynLook{
    width: 98px;
    height: 28px;
    line-height: 28px;
    text-align: center;
    background-color: #ffffff;
    border: solid 1px #e60012;
    font-size: 14px;
    color: #e60012;
    cursor: pointer;
}
.communDyn{
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 40px;
    .comhot{
        display: flex;
        align-items: center;
        span{
            margin-left: 15px;
        }
    }
}
.projiectOpen{
    li{
        cursor: pointer;
    }
}
.more {
        font-size: 14px;
        color: #666666;
        cursor: pointer;

        span {
            margin-right: 6px;
        }
    }
.apply{
    background: url('../../assets/home/home_application_bg.png') center center no-repeat;
    background-size: cover;
    ul{
        display: flex;
        margin-top: 40px;
        li{
            // height: 498px;
            padding: 20px;
            width: calc(33.33% - 20px);
            background-color: #ffffff;
            border-radius: 4px;
            border: solid 1px #f0f0f0;
            margin-right: 20px;
            img{
                width: 222px;
	            height: 159px;
            }
            p{
                font-size: 20px;
	            color: #222222;
                margin: 30px 0 15px;
            }
            .detail{
                font-size: 16px;
                line-height: 30px;
                color: #666666;
                height:90px;
                overflow:hidden;
                text-overflow:ellipsis;
                display:-webkit-box;
                -webkit-line-clamp:3;
                -webkit-box-orient:vertical;
            }
            .app{
                margin: 20px 0 13px;
                width: 56px;
                height: 22px;
                line-height: 22px;
	            background-color: #e60012;
                color: #fff;
                font-size: 12px;
                text-align: center;
            }
            .money{
                font-size: 20px;
	            color: #e60012;
                span{
                    font-size: 14px;
                }
            }
            .access{
                height: 36px;
	            background-color: #e60012;
                font-size: 14px;
                line-height: 36px;
                color: #ffffff;
                text-align: center;
                margin-top: 12px;
                cursor: pointer;
            }
        }
        :nth-child(3n){
            // width: 33.33%;
            margin-right: 0px;
        }
    }
}

.title_name {
    width: 100%;
    height: 148px;
    padding-top: 64px;
    padding-bottom: 50px;
    font-size: 36px;
    line-height: 36px;
    color: #222222;
    text-align: center;
}


.introduction {
    height: 1070px;
    background: url('../../assets/newhome/home_introduce_bg.png') center center no-repeat;
    background-size: cover;

    .fc {
        .introduce {
            position: relative;
            height: 859px;

            img {
                position: absolute;
                right: 0;
            }

            .framework,
            .user,
            .service,
            .value,
            .data,
            .application {
                position: absolute;
                width: 110px;
                height: 90px;
                cursor: pointer;
                // background-color: rgba(127, 255, 212, 0.219);
            }

            .framework {
                top: 131px;
                left: 287px;
            }


            .user {
                left: 0;
                bottom: 165px;
            }

            .service {
                left: 280px;
                bottom: 330px;
            }

            .value {
                top: 128px;
                right: 280px;
            }

            .data {
                top: 281px;
                right: 0;
            }

            .application {
                bottom: 334px;
                right: 279px;
            }

            .framework_text,
            .user_text,
            .service_text,
            .value_text,
            .data_text,
            .application_text {
                // background: url('../../assets/newhome/home_windows_bg.png') center center no-repeat;
                background: rgba(240, 242, 245, 0.8);
                background-size: cover;
                width: 280px;
                // height: 220px;
                padding: 19px 20px;
                // display: flex;
                // flex-direction: column;
                // justify-content: space-between;
                position: absolute;
                // display: none;

                // transition: opacity .6s ease-in-out;
                opacity: 0;
                // pointer-events: none;

                visibility: hidden;
                transition: all 0.6s linear;

                &:hover {
                    // display: block;
                    visibility: visible;
                    opacity: 1;
                }

                &::before,
                &::after {
                    content: "";
                    width: 16px;
                    height: 16px;
                    position: absolute;
                }

                &::before {
                    background: url('../../assets/newhome/home_windows_left.png') center center no-repeat;
                    top: 0;
                    left: 0;
                }

                &::after {
                    background: url('../../assets/newhome/home_windows_left02.png') center center no-repeat;
                    bottom: 0;
                    left: 0;
                }

                .name {
                    font-size: 18px;
                    color: #222222;
                    margin-bottom: 19px;
                    position: relative;

                    &::before {
                        content: "";
                        width: 16px;
                        height: 16px;
                        position: absolute;
                        background: url('../../assets/newhome/home_windows_right.png') center center no-repeat;
                        top: -19px;
                        right: -20px;
                    }
                }

                .desc {
                    // height: 125px;
                    font-size: 14px;
                    line-height: 23px;
                    color: #666666;
                    flex: 1;
                }

                .btn {
                    // width: 56px;
                    height: 14px;
                    font-size: 14px;
                    color: #0055ff;
                    position: relative;
                    margin-top: 18px;
                    cursor: pointer;

                    &::before {
                        content: "";
                        width: 16px;
                        height: 16px;
                        position: absolute;
                        background: url('../../assets/newhome/home_windows_right02.png') center center no-repeat;
                        bottom: -19px;
                        right: -20px;
                    }
                }
            }

            .framework_text {
                top: -36px;
                left: 205px;
            }

            .service_text {
                left: 193px;
                bottom: 380px;
            }

            // .user_text {
            //     left: -85px;
            //     bottom: 210px;
            // }
            // .data_text {
            //     top: 140px;
            //     right: -100px;
            // }
            .value_text {
                top: -15px;
                right: 210px;
            }

            .application_text {
                bottom: 384px;
                right: 198px;
            }

            .framework:hover+.framework_text {
                // display: block;
                opacity: 1;
                visibility: visible;
            }

            .user:hover+.user_text {
                // display: block;
                opacity: 1;
                visibility: visible;
            }

            .application:hover+.application_text {
                // display: block;
                opacity: 1;
                visibility: visible;
            }

            .service:hover+.service_text {
                // display: block;
                opacity: 1;
                visibility: visible;
            }

            .value:hover+.value_text {
                // display: block;
                opacity: 1;
                visibility: visible;
            }

            .data:hover+.data_text {
                // display: block;
                opacity: 1;
                visibility: visible;
            }
        }
    }
}


.capacity {
    height: 684px;
    background-color: #fafbfc;

    .banner_nav {
        height: 52px;
        display: flex;
        justify-content: space-around;
        box-shadow: 0px 6px 36px 4px rgba(240, 241, 245, 0.64);
        margin-bottom: 4px;

        li {
            width: 25%;
            font-size: 18px;
            color: #222222;
            text-align: center;
            line-height: 52px;
            cursor: pointer;
            background-color: #fff;
            // background-color: yellowgreen;


            &.active {
                background-color: #0055ff;
                color: #fff;
            }
        }
    }


    .capacity_banners {

        // 机理模型轮播
        .mechanismModel_banner {
            .group_list {

                .mechanism {
                    display: flex;
                }

                .mechanism_list {
                    // width: 290px;
                    height: 390px;
                    background-color: #ffffff;
                    // box-shadow: 0px 6px 36px 4px rgba(240, 241, 245, 0.64);
                    box-shadow: 0 2px 12px 0 #ced5f5;
                    margin-right: 20px;
                    padding: 30px 24px 18px;
                    display: flex;
                    flex-direction: column;
                    cursor: pointer;
                    transition: all .3s ease 0s;

                    &:nth-child(4n) {
                        margin-right: 0;
                    }

                    &:hover {
                        // box-shadow: 0px 6px 36px 4px #dce2f5;
                        transform: translateY(-10px);
                        box-shadow: 0 2px 12px 0 #ced5f5;

                    }

                    .mechanism_img {
                        width: 242px;
                        height: 120px;

                        img {
                            width: 100%;
                            height: 100%;
                        }
                    }

                    .mechanism_name {
                        font-size: 18px;
                        line-height: 18px;
                        margin-top: 32px;
                        margin-bottom: 13px;
                        color: #222222;
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        -o-text-overflow: ellipsis;
                    }

                    .mechanism_desc {
                        height: 155px;
                        font-size: 14px;
                        line-height: 26px;
                        color: #666666;
                        text-overflow: -o-ellipsis-lastline;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 6;
                        line-clamp: 1;
                        -webkit-box-orient: vertical;
                    }

                }

            }
        }

        // 微服务轮播
        .microService_banner {
            .group_list {

                .microService {
                    display: flex;
                    flex-wrap: wrap;
                }

                .microService_list {
                    // width: 290px;
                    height: 185px;
                    border-radius: 4px;
                    background-color: #ffffff;
                    // box-shadow: 0px 6px 36px 4px rgba(240, 241, 245, 0.64);
                    box-shadow: 0 2px 12px 0 #ced5f5;
                    margin-right: 20px;
                    padding: 22px 20px 18px;
                    display: flex;
                    flex-direction: column;
                    cursor: pointer;
                    transition: all .3s ease 0s;

                    &:nth-child(4n) {
                        margin-right: 0;
                    }

                    &:nth-of-type(-n + 4) {
                        margin-bottom: 18px;
                    }

                    &:hover {
                        // box-shadow: 0px 6px 36px 4px #dce2f5;
                        transform: translateY(-10px);
                        box-shadow: 0 2px 12px 0 #ced5f5;
                        // background-color: #0055ff;

                        // .microService_img .microService_name,
                        // .microService_desc {
                        //     color: #fff;
                        // }
                    }

                    .microService_img {
                        // width: 242px;
                        // height: 120px;
                        display: flex;
                        align-items: center;

                        img {
                            width: 24px;
                            height: 24px;
                            margin-right: 8px;
                        }

                        .microService_name {
                            font-size: 18px;
                            line-height: 17px;
                            color: #333333;
                            overflow: hidden;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                            -o-text-overflow: ellipsis;
                        }

                    }

                    .microService_desc {
                        margin-top: 10px;
                        font-size: 14px;
                        line-height: 22px;
                        color: #666666;
                        text-overflow: -o-ellipsis-lastline;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 5;
                        line-clamp: 1;
                        -webkit-box-orient: vertical;
                    }

                }

            }
        }

        // 工业app轮播
        .industry_banner {

            .group_list {

                .carousel_item {
                    display: flex;
                    flex-wrap: wrap;
                }

                .top_list {
                    height: 185px;
                    background-color: #ffffff;
                    // box-shadow: 0px 6px 36px 4px rgba(240, 241, 245, 0.64);
                    box-shadow: 0 2px 12px 0 #ced5f5;
                    border-radius: 4px;
                    margin-right: 20px;
                    padding: 23px 22px 22px 20px;
                    display: flex;
                    cursor: pointer;
                    transition: all .3s ease 0s;

                    &:nth-child(2n) {
                        margin-right: 0;
                    }

                    &:nth-of-type(-n + 2) {
                        margin-bottom: 20px;
                    }

                    &:hover {
                        // box-shadow: 0px 6px 36px 4px #dce2f5;
                        transform: translateY(-10px);
                        box-shadow: 0 2px 12px 0 #ced5f5;

                    }

                    .apply_img {
                        width: 242px;
                        height: 140px;
                        margin-right: 17px;

                        img {
                            width: 100%;
                            height: 100%;
                        }
                    }

                    .apply_detail {
                        width: 299px;
                        position: relative;

                        .top_name {
                            font-size: 18px;
                            line-height: 18px;
                            color: #222222;
                            margin-bottom: 20px;
                            overflow: hidden;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                            -o-text-overflow: ellipsis;
                        }

                        .top_detail {
                            height: 71px;
                            font-size: 14px;
                            line-height: 24px;
                            color: #666666;
                            text-overflow: -o-ellipsis-lastline;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            display: -webkit-box;
                            -webkit-line-clamp: 3;
                            line-clamp: 1;
                            -webkit-box-orient: vertical;
                        }

                        .top_but {
                            font-size: 14px;
                            color: #0055ff;
                            position: absolute;
                            left: 0;
                            bottom: 0;
                            // cursor: pointer;
                        }
                    }
                }

            }
        }
    }
}

.open {
    height: 894px;
    background: url(../../assets/newhome/home_codebg.png) center center no-repeat;

    .con {
        display: flex;

        .large {
            width: 792px;
            margin-right: 20px;
        }

        .small {
            flex: 1;
        }

        .chunk {
            width: 100%;
            height: 325px;
            // background: rgba(255, 255, 255, 0.4);
            background: #ffffff;
            border-radius: 6px;
            padding: 24px;

            h3 {
                font-size: 18px;
                margin-bottom: 26px;

                span {
                    font-size: 14px;
                    color: #666666;
                    margin-left: 12px;
                    font-weight: normal;
                }
            }
        }

        .platform {
            margin-bottom: 32px;
            padding-right: 43px;

            .especially {
                display: flex;

                &>img {
                    width: 224px;
                    height: 219px;
                }

                .especially_con {
                    flex: 1;
                    margin-left: 23px;
                }

                ul {
                    display: flex;
                    justify-content: space-between;

                    li {
                        text-align: center;
                        width: 100px;

                        p {
                            margin-top: 8px;
                            font-size: 14px;
                        }
                    }
                }

                .process {
                    margin-top: 44px;

                    .next {
                        width: 16px;
                        padding-top: 20px;
                    }
                }
            }
        }

        .coder {

            // background: rgba(255, 255, 255, 0.4);
            .especially {
                &>img {
                    width: 224px;
                    height: 212px;
                }

                .especially_con {
                    margin-left: 33px;

                    ul {
                        width: 454px;

                        li {
                            width: 70px;
                            // margin-right: 37px;
                        }
                    }
                }

                .discuss {
                    margin-top: 32px;
                    width: 466px;

                    .dis_title {
                        display: flex;
                        justify-content: space-between;
                        padding-left: 10px;
                        border-left: 3px solid #0055ff;
                        line-height: 16px;
                        margin-bottom: 16px
                    }

                    .dis_list {
                        .dis_item {
                            a {
                                font-size: 14px;
                                color: #666666;
                                display: flex;
                                justify-content: space-between;
                                align-items: center;
                                cursor: pointer;
                                margin-bottom: 10px;

                                p {
                                    width: 557px;
                                }
                            }

                        }
                    }
                }
            }


        }

        .application {
            margin-bottom: 32px;

            .app_list {
                padding-top: 6px;

                .app_item {
                    display: flex;
                    cursor: pointer;
                    margin-bottom: 24px;

                    img {
                        width: 96px;
                        height: 50px;
                        border-radius: 4px;
                        flex-shrink: 0;
                    }

                    .more {
                        flex-shrink: 0;
                        display: block;
                        width: 12px;
                        height: 12px;
                        background: url(../../assets/home/home_more.png);
                        
                    }

                    .app_info {
                        flex: 1;
                        width: 0;
                        margin-left: 14px;

                        h4 {
                            font-weight: 400;
                        }

                        .desc {
                            font-size: 14px;
                            color: #666666;
                            margin-top: 10px;
                        }
                    }
                }
            }
        }

        .lowcode {
            .code_con {
                display: flex;

                ul {
                    display: flex;
                    flex-wrap: wrap;
                    width: 151px;

                    li {
                        width: 50%;
                        text-align: center;

                        &:nth-of-type(-n+4) {
                            margin-bottom: 20px;
                        }

                        p {
                            font-size: 14px;
                            line-height: 14px;
                            margin-top: 4px;
                        }
                    }
                }

                .experience {
                    font-size: 14px;
                    padding-left: 38px;
                    border-left: 1px solid #ffffff;

                    p {
                        margin-bottom: 23px;
                        padding-left: 16px;
                        position: relative;

                        &:nth-child(1) {
                            margin-top: 20px;
                        }

                        &::before {
                            content: "";
                            width: 6px;
                            height: 6px;
                            border-radius: 3px;
                            background: #0055ff;
                            position: absolute;
                            top: 7px;
                            left: 0;
                        }
                    }

                    .btn {
                        display: block;
                        width: 100%;
                        height: 32px;
                        line-height: 32px;
                        text-align: center;
                        color: #ffffff;
                        border-radius: 6px;
                        font-size: 14px;
                        background: #0055ff;
                        margin-top: 30px;
                    }
                }
            }
        }
    }
}

.superiority {
    height: 710px;

    .containt {
        display: flex;

        .left_nav {
            margin-right: 20px;

            li {
                width: 290px;
                margin-bottom: 20px;
                cursor: pointer;

                &:last-child {
                    margin-bottom: 0;
                }
            }

            span {
                display: inline-block;
                margin-top: 2px;
            }

            .left_nav_normal {
                height: 88px;
                background-image: linear-gradient(180deg,
                        #f4f6f9 0%,
                        #fdfdfe 100%);
                box-shadow: 0px 6px 36px 4px rgba(240, 241, 245, 0.64);
                border: solid 1px #ffffff;
                color: #222222;
                padding: 36px 24px 36px 20px;
                display: flex;
                justify-content: space-between;
                align-items: center;



            }

            .left_nav_active {
                height: 174px;
                box-shadow: 0px 6px 36px 4px rgba(240, 241, 245, 0.64);
                background: url('../../assets/newhome/home_advantage_bg.png') bottom no-repeat;
                background-color: #0055ff;
                padding: 20px;
                color: #ffffff;

                .name {
                    width: 246px;
                    display: flex;
                    justify-content: space-between;
                    margin-bottom: 9px;
                }

                .desc {
                    width: 249px;
                    height: 98px;
                    font-size: 14px;
                    line-height: 28px;
                }
            }
        }

        .right_nav {
            li {
                transition: all .3s ease 0s;
            }

            .one {
                display: flex;
                flex-wrap: wrap;

                li {
                    width: 290px;
                    height: 239px;
                    background-color: #ffffff;
                    box-shadow: 0px 6px 36px 4px rgba(240, 241, 245, 0.64);
                    margin-right: 20px;



                    &:hover {
                        box-shadow: 0px 6px 36px 4px #dce2f5;
                    }

                    &:nth-of-type(-n + 3) {
                        margin-bottom: 20px;
                    }

                    &:nth-child(3n) {
                        margin-right: 0;
                    }

                    .name {
                        padding-left: 23px;
                        line-height: 18px;
                        font-size: 18px;
                        color: #222222;
                        margin-top: 10px;
                    }

                    .desc {
                        padding: 12px 24px 19px 24px;
                        height: 106px;
                        font-size: 14px;
                        line-height: 24px;
                        color: #666666;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        line-clamp: 1;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 4;
                    }
                }
            }

            .two {
                display: flex;
                height: 498px;

                li {
                    width: 212px;
                    box-shadow: 0px 6px 36px 4px rgba(240, 241, 245, 0.64);
                    margin-right: 20px;

                    &:last-child {
                        margin-right: 0;
                    }

                    &:hover {
                        box-shadow: 0px 6px 36px 4px #dce2f5;
                    }

                    img {
                        width: 212px;
                        height: 144px;
                    }

                    .text {
                        height: 354px;
                        background-image: linear-gradient(180deg,
                                #ebeff5 0%,
                                #ffffff 100%);
                        margin-top: -5px;
                        padding: 20px 18px;

                        .name {
                            font-size: 16px;
                            color: #222222;
                            margin-bottom: 11px;
                        }

                        .desc {
                            width: 172px;
                            height: 206px;
                            font-size: 14px;
                            line-height: 24px;
                            color: #666666;
                        }
                    }
                }
            }

            .three {
                display: flex;
                flex-wrap: wrap;
                list-style: none;

                li {
                    width: 445px;
                    height: 152px;
                    background-color: #ffffff;
                    box-shadow: 0px 6px 36px 4px rgba(240, 241, 245, 0.64);
                    position: relative;

                    &:nth-child(odd) {
                        margin-right: 20px;
                    }

                    &:nth-of-type(-n + 4) {
                        margin-bottom: 21px;
                    }

                    &:hover {
                        background-color: #0055ff;

                        .desc {
                            color: #fff;
                        }

                        .normal_img {
                            display: none;
                        }

                        .active_img {
                            display: block;
                        }
                    }

                    &>div {
                        display: flex;
                        padding: 36px 20px 36px 26px;
                        align-items: center;
                        justify-content: space-between;
                    }

                    .active_img {
                        display: none;
                    }

                    .num_img {
                        width: 37px;
                        height: 34px;
                    }

                    .dot_img {
                        position: absolute;
                        bottom: 6px;
                        left: 6px;
                    }

                    .line_img {
                        width: 1px;
                        height: 60px;
                    }

                    .desc {
                        width: 306px;
                        font-size: 14px;
                        line-height: 28px;
                        color: #222222;
                    }
                }
            }

            .four {
                display: flex;
                flex-wrap: wrap;
                list-style: none;

                li {
                    width: 445px;
                    height: 239px;
                    background-image: linear-gradient(180deg,
                            #ebeff5 0%,
                            #ffffff 100%);
                    box-shadow: 0px 6px 36px 4px rgba(240, 241, 245, 0.64);
                    border: solid 1px #ffffff;
                    padding: 32px 20px 26px;

                    &:nth-child(odd) {
                        margin-right: 20px;
                    }

                    &:nth-of-type(-n + 2) {
                        margin-bottom: 20px;
                    }

                    &:hover {
                        box-shadow: 0px 6px 36px 4px #dce2f5;
                    }

                    img {
                        width: 60px;
                        height: 52px;
                        margin-bottom: 20px;

                    }

                    .name {
                        font-size: 16px;
                        line-height: 16px;
                        color: #222222;
                    }

                    .desc {
                        margin-top: 10px;
                        font-size: 14px;
                        line-height: 28px;
                        color: #666666;
                    }
                }
            }

        }
    }
}

.achievement {
    height: 826px;
    background-color: #fafbfc;

    .containt {
        display: flex;

        ul {
            width: 280px;
            height: 614px;

            li {
                width: 280px;
                height: 138px;
                margin-bottom: 21px;
                padding: 36px 24px 34px;
                background: url(../../assets/newhome/home_achievement_bg.png) center center no-repeat;
                display: flex;
                flex-direction: column;
                justify-content: space-between;

                p {
                    font-size: 18px;
                    color: #222222;

                    span {
                        font-size: 30px;
                        color: #0055ff;
                    }
                }
            }
        }

        .chart {
            width: 614px;
            height: 614px;
            margin: 0 23px;

            #myChart {
                height: 100%;
            }
        }
    }
}

.case {
    // height: 302px;

    .swiper-container .swiper-wrapper {
        -webkit-transition-timing-function: linear;
        /*之前是ease-out*/
        -moz-transition-timing-function: linear;
        -ms-transition-timing-function: linear;
        -o-transition-timing-function: linear;
        transition-timing-function: linear;
    }

    .swiper-container {
        // height: 260px;
        padding: 30px 0;
        margin-top: -30px;
    }

    .swiper-slide {
        width: 186px !important;
        margin-right: 21px;

        // &:nth-child(6n) {
        //     margin-right: 0;
        // }

        &>div {
            width: 186px;
            height: 90px;
            margin-bottom: 20px;
            background-color: #ffffff;
            box-shadow: 0px 6px 36px 4px rgba(240, 241, 245, 0.64);
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 10px;
            box-sizing: border-box;

            img {
                width: 166px;
                height: 70px;
            }
        }
    }

    .no_data {
        padding: 0px;
        margin-bottom: 64px;
    }
}
.nodata {
    padding: 60px;
    text-align: center;

    p {
        margin-top: 20px;
        color: #666666;
    }
}
</style>